import moment from "moment";
export var formatTimeStamp = function (timestamp) {
    return moment(timestamp).toString();
};
export var timeFromNow = function (timestamp) { return moment(timestamp).fromNow(); };
